import classNames from 'classnames';

import ErrorBoundary from '../../components/error_boundary/error_boundary';
import type { FCC } from '../../types/common';

import styles from './page_content.module.css';

export type PageGutterSize = 'xs' | 'm';

type Props = {
  // Adds left and right padding to the content; `true` is the default `xs` size
  gutter?: boolean | PageGutterSize;
};

const PageContent: FCC<Props> = ({ children, gutter }) => (
  <div
    className={classNames(
      {
        [styles.gutter]: gutter === true || gutter === 'xs',
        [styles.gutter_m]: gutter === 'm',
      },
      styles.root,
    )}
  >
    <ErrorBoundary>{children}</ErrorBoundary>
  </div>
);

export default PageContent;
